import $ from 'jquery';
import domain from './utils/getDomain';
import serializeForm from './utils/serializeForm';
import validateForm from './utils/validateForm';

export default class Tests {
  static init() {
    this.correctAnswers = 0;
    this.allQuestions = 0;

    $(() => {
      $('.questions__send').on('click', () => {
        this.checkAnswers();
      });
    });
  }

  static checkAnswers() {
    this.checkUserAnswers();
  }

  static checkUserAnswers() {
    if (this.emptyQuestionIsPresent() === true) {
      $.fancybox.open({
        src: '#need-answer',
        closeExisting: true,
        smallBtn: false,
        toolbar: false,
        touch: false
      });

      return;
    }

    if (!validateForm('.test-single__form')) {
      window.scrollTo({
        top: $('.input--error')
          .first()
          .offset().top,
        behavior: 'smooth'
      });

      return;
    }

    $('.questions__single input:checked').each((i, el) => {
      const closestsLabel = $(el).closest('label');
      this.addClassesToInputs(closestsLabel);
    });

    $('body').addClass('test-passed');
    this.setFinishScore();
    this.setDisableForInputs();
    this.submitForm();
  }

  static submitForm() {
    let args = serializeForm('#test-info');

    $.post(`${domain}/wp-json/rdz/v1/tests/`, args)
      .done(() => {})
      .fail(err => {
        console.log(err);
      });
  }

  static emptyQuestionIsPresent() {
    let emptyIsPresent = false;
    let textForPopup = '';

    $('.questions__single').each((index, el) => {
      if ($(el).find('input:checked').length === 0) {
        if (textForPopup === '') {
          textForPopup += `№ ${index + 1}`;
        } else {
          textForPopup += `, ${index + 1}`;
        }
        emptyIsPresent = true;
      }
    });
    $('[data-answer-question]').html(textForPopup);

    return emptyIsPresent;
  }

  static setFinishScore() {
    this.allQuestions = $('.questions__single').length;
    this.correctAnswers = $('.questions__single--correct').length;

    $('[data-correct-answers]').html(this.correctAnswers);
    $('[data-all-answers]').html(this.allQuestions);
  }

  static setDisableForInputs() {
    $('.questions__single input').attr('disabled', true);
  }

  static addClassesToInputs(label) {
    if (label.hasClass('questions--correct')) {
      if (this.getTypeOfInputs(label) === 'radio') {
        label.addClass('radio--correct');
      } else {
        label.addClass('checkbox--correct');
      }

      label
        .closest('.questions__single')
        .addClass('questions__single--correct');
    } else {
      if (this.getTypeOfInputs(label) === 'radio') {
        label.addClass('radio--mistake');
      } else {
        label.addClass('checkbox--mistake');
      }
      label.closest('.questions__single').addClass('questions__single--wrong');
    }
  }

  static getTypeOfInputs(element) {
    return $(element)
      .find('input')
      .first()
      .attr('type');
  }
}
